import { render, staticRenderFns } from "./EngagementDetails.vue?vue&type=template&id=52ef3e1b&scoped=true&"
import script from "./EngagementDetails.vue?vue&type=script&lang=ts&"
export * from "./EngagementDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EngagementDetails.vue?vue&type=style&index=0&id=52ef3e1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef3e1b",
  null
  
)

export default component.exports